import {
  type MutationHookOptions,
  type RefreshTokenMutation,
  type RefreshTokenMutationVariables,
  useRefreshTokenMutation,
} from "@qw/graphql";
import { useSetAtom } from "jotai";
import { authDataAtom, authTokenValidatedAtom } from "../atoms";

export function useRefreshToken(options?: MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
  const setAuthData = useSetAtom(authDataAtom);
  const setTokenValidated = useSetAtom(authTokenValidatedAtom);

  return useRefreshTokenMutation({
    ...options,
    onCompleted: (data) => {
      setAuthData((authData) => ({
        token: data.refreshToken,
        shouldRemember: authData?.shouldRemember ?? false,
      }));
      setTokenValidated(true);
      options?.onCompleted?.(data);
    },
    onError: (error) => {
      setAuthData(null);
      options?.onError?.(error);
    },
  });
}
